import { useState } from "react";
import { api, formatApiErrorDetail } from "../../lib/api";
import { Field } from "./fields";
import { toast } from "sonner";
import { Loader2, KeyRound } from "lucide-react";

export const SeguridadTab = () => {
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (next !== confirm) return toast.error("Las contraseñas nuevas no coinciden.");
    setBusy(true);
    try {
      await api.post("/auth/change-password", { current_password: current, new_password: next });
      toast.success("Contraseña actualizada correctamente.");
      setCurrent(""); setNext(""); setConfirm("");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail));
    } finally {
      setBusy(false);
    }
  };

  return (
    <form onSubmit={submit} className="space-y-5 max-w-sm">
      <h3 className="font-serif-display text-lg font-semibold text-[#071D4D] flex items-center gap-2">
        <KeyRound size={18} /> Cambiar contraseña
      </h3>
      <Field label="Contraseña actual" type="password" testId="seguridad-actual" value={current} onChange={setCurrent} />
      <Field label="Nueva contraseña (mínimo 8 caracteres)" type="password" testId="seguridad-nueva" value={next} onChange={setNext} />
      <Field label="Confirmar nueva contraseña" type="password" testId="seguridad-confirmar" value={confirm} onChange={setConfirm} />
      <button data-testid="seguridad-submit" disabled={busy || !current || !next}
        className="inline-flex items-center gap-2 rounded-full bg-[#0057FF] text-white text-sm px-5 py-2.5 disabled:opacity-60">
        {busy && <Loader2 size={15} className="animate-spin" />} Actualizar contraseña
      </button>
    </form>
  );
};
